import { Component, Input, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { CommonModule, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { DIALOG_MODE_IDENTIFIER, IoniconsFilled } from '@pt/pt-models';
import { IonicModule } from '@ionic/angular';
import { HelpTooltipDialogComponent } from '@pt/dialog';

@Component({
  selector: 'pt-w-help',
  standalone: true,
  imports: [
    CommonModule,
    NgSwitch,
    NgIf,
    NgSwitchCase,
    NgbPopover,
    IonicModule
  ],
  template: `
<!--    {{mode}}-->
<!--    {{currentHelp}}-->
<!--    <ion-icon name='{{IconInfoCircle}}'-->
<!--              [ngStyle]="{'font-size': 18 + 'px'}"-->
<!--              class='ion-icon widget-info-icon-color' title=''></ion-icon>-->

    <ng-container *ngIf='currentHelp'>
      <ng-container [ngSwitch]='mode'>
        <ion-icon *ngSwitchCase="'TOOLTIP'"
                  name='{{IconInfoCircle}}'
                  [ngStyle]="{'font-size': 18 + 'px'}"
                  title=''
                  class='ion-icon widget-info-icon-color cursor-pointer'
                  ngbPopover='{{currentHelp}}'
                  container='body'
                  triggers="hover"
                  placement='top'
                  popoverClass='help-popover-top'>
        </ion-icon>

        <ion-icon *ngSwitchCase="'DIALOG'"
                  name='{{IconInfoCircle}}'
                  [ngStyle]="{'font-size': 18 + 'px'}"
                  class='ion-icon widget-info-icon-color cursor-pointer'
                  (click)='openHelpDialog(currentHelp);  $event.stopPropagation();'
                  title=''>
        </ion-icon>


      </ng-container>
    </ng-container>
  `
})
export class WidgetHelpComponent implements OnInit {
  @Input() help = '';

  IconInfoCircle = IoniconsFilled.infoCircle;
  currentHelp?: string;
  mode: WidgetHelpMode = 'TOOLTIP';

  constructor(private modalService: NgbModal, private translateService: TranslateService) {
  }


  openHelpDialog(help?: string) {
    const modalRef = this.modalService.open(HelpTooltipDialogComponent,
      {
        size: 'lg',
        keyboard: true,
        centered: true
      });
    modalRef.componentInstance.run(this.translateService.stream('TITLE.HELP'), help);
    from(modalRef.result).subscribe();
  }

  ngOnInit(): void {
    if (this.help?.length > 0) {
      if (this.help.startsWith(DIALOG_MODE_IDENTIFIER)) {
        this.currentHelp = this.help.replace(DIALOG_MODE_IDENTIFIER, '');
        this.mode = 'DIALOG';
      } else {
        this.currentHelp = this.help;
        this.mode = 'TOOLTIP';
      }
    }
  }
}

type WidgetHelpMode = 'TOOLTIP' | 'DIALOG';
